import { useAuth } from '@/components/auth/authProvider';
import { isInternalUser } from '@/components/auth/RequireIsInternalUser';

import { OrganizationType } from 'types';

// Checks the home org rather than the viewed org, so impersonating a child org doesn't change the answer.
const useIsIntegratedPartnerUser = (): boolean => {
  const { claims, homeOrganizationData } = useAuth();
  return (
    !isInternalUser(claims, true) &&
    !!homeOrganizationData?.organizationTypes?.includes(OrganizationType.integratedPlatform)
  );
};

export default useIsIntegratedPartnerUser;
